"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const FarmTable_vue_1 = __importDefault(require("./components/FarmTable.vue"));
const FarmListController_1 = __importDefault(require("./modules/controllers/FarmListController"));
const MapZone_1 = __importDefault(require("../Map/models/MapZone"));
const Utils_1 = require("../Map/Utils");
const ViewZero_vue_1 = __importDefault(require("../Profile/Access/components/ViewZero.vue"));
const Loader_vue_1 = __importDefault(require("./components/Loader.vue"));
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const format_1 = require("ol/format");
const GeometryCollection_1 = __importDefault(require("ol/geom/GeometryCollection"));
const FarmSetupCTA_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/FarmSetupCTA.vue"));
const AIGenInfoModal_vue_1 = __importDefault(require("./components/AIGenInfoModal.vue"));
let ClientFarmListView = class ClientFarmListView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.MAP_ID = 'preview-map-container';
        this.MAP_CONTROLLER = new Controller_1.default();
        this.CONTROLLER = FarmListController_1.default.getInstance();
        this.loaderSearch = false;
        this.textFilter = '';
        this.farmsFilters = [];
        this.allFarmPagesLoaded = false;
        this.activeFarm = undefined;
        this.isAIGenModalActive = false;
        /*  async drawFieldInMap() {
             this.CONTROLLER.selectedFarms.forEach((field: Farm) => {
                 this.MAP_CONTROLLER.zoneBuilder.drawZone(
                     new MapZone({
                         geoData: field.geodata,
                         fillColor: field.crop ? `${field.crop?.color}50` : '#eebb5460',
                         strokeColor: field.crop ? field.crop?.color : '#eebb54',
                         enableHoverInteraction: true,
                         enableSelectInteraction: true,
                         zoneName: `${field.id}-${field.fieldName}`,
                         centerZone: false,
                         avg: 0,
                         markers: [],
                         preciseResult: false,
                         modifyInteraction: true
                     }),
                     700,
                     [50, 50, 50, 50],
                 );
             })
    
             const polygonsWkt = this.fields_wkt.map(parseWKT);
             const combinedGeometry = new GeometryCollection(polygonsWkt);
             const extent = transformExtent(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
             await center(this.MAP_CONTROLLER.map, extent, 700, [50, 50, 50, 50]);
         } */
    }
    get isBiome() {
        return (this.raw_user.role === 1 || this.raw_user.biome_level > 0) ? true : false;
    }
    get currentPage() {
        return this.CONTROLLER.currentPage;
    }
    get isBMK() {
        return this.raw_user.is_bmk && parseInt(this.raw_user.role) === 1;
    }
    async loadPage(page) {
        var _a;
        this.textFilter = '';
        this.farmsFilters = [];
        const pageM = page;
        if (this.CONTROLLER.farmsPages.some(entry => entry.page === pageM)) {
            this.CONTROLLER.farmsCurrentPage = ((_a = this.CONTROLLER.farmsPages.find((farmPage) => { return farmPage.page === pageM; })) === null || _a === void 0 ? void 0 : _a.farms) || [];
            this.CONTROLLER.currentPage = pageM;
        }
        else {
            await this.CONTROLLER.changeFarmListPage(pageM);
        }
        this.drawFarmInMap(this.CONTROLLER.farmsCurrentPage[0]);
    }
    get farmsPage() {
        var _a;
        return (_a = this.CONTROLLER.farmsPages.find((farmPage) => { return farmPage.page === this.CONTROLLER.currentPage; })) === null || _a === void 0 ? void 0 : _a.farms;
    }
    deployAIGenModal() {
        this.isAIGenModalActive = true;
    }
    dismissAIGenModal() {
        this.isAIGenModalActive = false;
    }
    dismissModal() {
        this.dismissAIGenModal();
    }
    updateURL() {
        const params = new URLSearchParams(window.location.search);
        params.delete('just_created');
        params.delete('new_farms');
        const newUrl = (params.toString().length > 0)
            ? window.location.pathname + '?' + params.toString()
            : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }
    async mounted() {
        const params = new URLSearchParams(window.location.search);
        const farmIdParam = params.get('farm_id');
        const farmId = farmIdParam !== null ? parseInt(farmIdParam) : null;
        this.MAP_CONTROLLER.create(this.MAP_ID, this.map_config.provider, this.map_config.apikey, '', '', '', 13, 0, 17);
        await this.CONTROLLER.changeFarmListPage(1, farmId);
        if (farmId !== null) {
            this.filterFarm(farmId);
        }
        if (params.get('just_created') === 'true') {
            const newFarmParam = params.get('new_farms');
            const numNewFarms = newFarmParam !== null ? parseInt(newFarmParam) : 1;
            const farms = this.farms;
            if (farms.slice(0, numNewFarms).some((f) => f.eBeCrop_compatible && !f.eBeCrop_ready)) {
                this.deployAIGenModal();
            }
        }
        this.updateURL();
        // Preload next pages in background
        this.allFarmPagesLoaded = await this.CONTROLLER.preloadNextPages();
    }
    filterFarm(farmId) {
        const filteredFarm = this.farms.find((farm) => farm.id === farmId);
        if (filteredFarm !== undefined) {
            this.farmsFilters.push(filteredFarm);
            this.textFilter = filteredFarm.name;
        }
    }
    onSearchChange(f) {
        this.loaderSearch = true;
        this.textFilter = f;
        if (f.length > 0) {
            this.farmsFilters = this.CONTROLLER.farms
                .filter((farm) => farm.name.toUpperCase().trim().includes(f.toUpperCase().trim())).map((sam) => sam);
            if (this.farmsFilters[0]) {
                this.drawFarmInMap(this.farmsFilters[0]);
            }
        }
        else {
            this.textFilter = null;
            this.farmsFilters = this.CONTROLLER.farms;
            this.drawFarmInMap(this.CONTROLLER.farmsCurrentPage[0]);
        }
        this.loaderSearch = false;
    }
    get farms() {
        return this.CONTROLLER.farms;
    }
    get mapInstance() {
        return this.MAP_CONTROLLER.map;
    }
    async drawFarmInMap(farm) {
        this.activeFarm = farm;
        if (this.farms.length > 0) {
            const layer = (0, Utils_1.findLayerById)('zone-layer', this.mapInstance);
            const centerPadding = [100, 100, 100, 100];
            const centerAnimationDuration = 700;
            if (layer) {
                const source = layer.getSource();
                source.clear();
            }
            if (!!farm.gis_fields) {
                const polygonsWkt = [];
                farm.gis_fields.forEach((gisField) => {
                    const feature = new format_1.WKT().readFeature(gisField.geodata, this.MAP_CONTROLLER.zoneBuilder.projections);
                    polygonsWkt.push(feature.getGeometry());
                    this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                        geoData: gisField.geodata,
                        fillColor: '#eebb5460',
                        strokeColor: '#eebb54',
                        enableHoverInteraction: false,
                        enableSelectInteraction: false,
                        zoneName: `${gisField.id}-${gisField.name}`,
                        centerZone: false,
                        avg: 0,
                        markers: [],
                        preciseResult: false,
                        modifyInteraction: false
                    }));
                });
                const combinedGeometry = new GeometryCollection_1.default(polygonsWkt);
                (0, CenterUtility_1.center)(this.MAP_CONTROLLER.map, combinedGeometry.getExtent(), centerAnimationDuration, centerPadding);
            }
            else {
                this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                    geoData: farm.geodata,
                    fillColor: '#eebb5460',
                    strokeColor: '#eebb54',
                    enableHoverInteraction: false,
                    enableSelectInteraction: false,
                    zoneName: `${farm.id}-${farm.name}`,
                    centerZone: true,
                    avg: 0,
                    markers: [],
                    preciseResult: false,
                    modifyInteraction: false
                }), centerAnimationDuration, centerPadding);
            }
        }
    }
    onMapExport() {
        if (this.activeFarm) {
            const format = 'kml';
            const filename = this.activeFarm.name + ' - ' + format;
            this.MAP_CONTROLLER.exportBuilder.export(filename, format);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClientFarmListView.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClientFarmListView.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClientFarmListView.prototype, "raw_user", void 0);
ClientFarmListView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, MapAttributions: bmk_ui_framework_1.MapAttributions, Search: bmk_ui_framework_1.Search, Plus: lucide_vue_next_1.Plus, Minus: lucide_vue_next_1.Minus, Download: lucide_vue_next_1.Download, FarmTable: FarmTable_vue_1.default, Pagination: bmk_ui_framework_1.Pagination, ViewZero: ViewZero_vue_1.default, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon, Loader: Loader_vue_1.default, FarmSetupCTA: FarmSetupCTA_vue_1.default, AIGenInfoModal: AIGenInfoModal_vue_1.default }
    })
], ClientFarmListView);
exports.default = ClientFarmListView;
